/**
 * Validation methods take the target element as the first argument
 * Always return an object like...
 * {
 *  valid: Boolean,
 *  message: 'Message to show to user'
 * }
 */

const matchField = (field, fieldToMatch) => ({
  valid: field.value === fieldToMatch.value,
  message: `Field should match ${
    fieldToMatch.name === 'newpassword'
      ? 'new password'
      : fieldToMatch.name
  }`
});

const maxAmount = (field, fieldToCheck) => ({
  valid: field.value <= fieldToCheck,
  message: 'Amount should not exceed remaining balance'
});

const remainingBalance = (customAmount, fullBalance) => ({
  valid: fullBalance - customAmount.value >= 1 || fullBalance - customAmount.value === 0,
  message: 'You cannot make a payment that leaves the outstanding balance less than £1'
});

export {
  matchField,
  maxAmount,
  remainingBalance
};